// src/dialog/utils/is-backdrop.ts
function isBackdrop(element) {
  if (!element) return false;
  const backdrop = element.getAttribute("data-backdrop");
  if (backdrop == null) return false;
  if (backdrop === "") return true;
  if (backdrop === "true") return true;
  for (var _len = arguments.length, ids = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    ids[_key - 1] = arguments[_key];
  }
  if (!ids.length) return true;
  return ids.some(id => backdrop === id);
}
export { isBackdrop };